import React, { useState, useEffect, useContext } from 'react'
import { useQuery } from '@apollo/client'
import { Header, Segment } from 'semantic-ui-react'
import MixpanelTracker from '../../utils/MixpanelTracker'
import DataContext from '../../contexts/DataContext'
import { SINGLE_PROJECT_PUBLIC_QUERY } from '../../graphql/project'
import Schedule from '../../components/PublicProject/Schedule'
import ConfirmRegister from '../../components/PublicProject/ConfirmRegister'
import NotFoundPage from '../NotFoundPage'
import Loading from '../../components/Loading'
import ExistingResponseAlert from '../../components/PublicProject/ExistingResponseAlert'
import WorkConfirmation from '../../components/WorkConfirmation'
import TimeZoneConfirmation from '../../components/Schedule/TimeZoneConfirmation'

const Register = ({ project, qualificationResponses }) => {
  const { advisor } = useContext(DataContext)

  const isExistingExpert = advisor.expert !== null
  const hasResponded = advisor.jobs.find(
    (job) =>
      job.project.id === project.id &&
      !['Pending Scheduling', 'Client Reschedule'].includes(job.overall_status)
  )

  const [jobData, setJobData] = useState({
    meetingAt: null,
    qualificationResponses,
  })
  const [page, setPage] = useState(
    hasResponded
      ? 'EXISTING_RESPONSE_ALERT'
      : isExistingExpert
      ? 'WORK_CONFIRMATION'
      : project.type === 'Interview'
      ? 'TIMEZONE_CONFIRMATION'
      : 'CONFIRM_REGISTER'
  )

  useEffect(() => {
    MixpanelTracker.trackViewPublicProjectRegister(advisor, hasResponded)
  }, [advisor, hasResponded])

  const removeLocalStorage = () => {
    localStorage.removeItem('publicProject')
    localStorage.removeItem('qualification')
  }

  const PAGES = {
    WORK_CONFIRMATION: (
      <Segment>
        <WorkConfirmation
          project={project}
          onNext={() =>
            setPage(
              project.type === 'Interview'
                ? 'TIMEZONE_CONFIRMATION'
                : 'CONFIRM_REGISTER'
            )
          }
        />
      </Segment>
    ),
    TIMEZONE_CONFIRMATION: (
      <Segment>
        <TimeZoneConfirmation project={project} setPage={setPage} />
      </Segment>
    ),
    SCHEDULE: (
      <Schedule
        project={project}
        updateMeetingAt={(meetingAt) => setJobData({ ...jobData, meetingAt })}
        setPage={setPage}
      />
    ),
    CONFIRM_REGISTER: (
      <ConfirmRegister jobData={jobData} project={project} setPage={setPage} />
    ),
    EXISTING_RESPONSE_ALERT: (
      <ExistingResponseAlert project={project} onClose={removeLocalStorage} />
    ),
  }

  return (
    <div>
      <Header>{project.title}</Header>
      {PAGES[page]}
    </div>
  )
}

const PublicProjectRegister = () => {
  const storedProject = JSON.parse(localStorage.getItem('publicProject'))
  const qualificationResponses = JSON.parse(
    localStorage.getItem('qualification')
  )
  const { loading, data } = useQuery(SINGLE_PROJECT_PUBLIC_QUERY, {
    variables: { id: storedProject?.id },
    skip: !storedProject,
    fetchPolicy: 'network-only',
  })

  if (!storedProject || !qualificationResponses) {
    return (
      <NotFoundPage message="If you received an invitation to a Dexter project, please go back to the invitation link and start over." />
    )
  }

  if (loading) return <Loading />

  const project = data?.project || storedProject

  return (
    <Register
      project={project}
      qualificationResponses={qualificationResponses}
    />
  )
}

export default PublicProjectRegister
